'use client';

import { useEffect } from 'react';
import { NextIntlClientProvider } from 'next-intl';
import { RuntimeErrorCard } from '@/components/errors/RuntimeErrorCard';
import { GLOBAL_ERROR_MESSAGES } from './global-error-messages';

/**
 * Next.js App Router 全局错误页
 * 捕获 root layout 级别的错误并上报 Sentry
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const locale = (() => {
    if (typeof document === 'undefined') return 'zh';

    const documentLang = document.documentElement.lang;
    if (documentLang.startsWith('zh')) return 'zh';
    if (documentLang.startsWith('en')) return 'en';

    const localeCookie = document.cookie
      .split('; ')
      .find((item) => item.startsWith('NEXT_LOCALE='))
      ?.split('=')[1];
    return localeCookie === 'en' ? 'en' : 'zh';
  })();
  const messages = GLOBAL_ERROR_MESSAGES[locale];

  useEffect(() => {
    console.error('[GlobalError]', error);
  }, [error]);

  return (
    <html lang={locale} translate="no" className="notranslate">
      <body>
        <NextIntlClientProvider locale={locale} messages={messages}>
          <RuntimeErrorCard
            context="app"
            layout="fullscreen"
            error={error}
            onRetry={reset}
            onRefresh={() => window.location.reload()}
          />
        </NextIntlClientProvider>
      </body>
    </html>
  );
}
